/**
 * One-time reveal animations use a shared IntersectionObserver rather than
 * a persistent ScrollTrigger for every section.
 */
export function initScrollAnimations() {
	const gsap = window.gsap;
	if ( ! gsap || window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) return;

	const targets = [
		...document.querySelectorAll( '.container, .container-fluid, section.db-stl' ),
	].filter( ( element ) => ! shouldSkipSectionReveal( element ) );

	const footerColumns = [
		...document.querySelectorAll( '.site-footer__columns > .row > [class*="col-"]' ),
	];
	const newsletter = document.querySelector( '.site-footer__newsletter' );

	if ( ! targets.length && ! footerColumns.length && ! newsletter ) return;

	const revealSection = ( element ) => {
		if ( element.dataset.scrollRevealInit ) return;
		element.dataset.scrollRevealInit = '1';

		gsap.fromTo(
			element,
			{ y: 45, autoAlpha: 0 },
			{ y: 0, autoAlpha: 1, duration: 0.9, ease: 'power2.out', overwrite: 'auto' }
		);
	};

	if ( ! ( 'IntersectionObserver' in window ) ) {
		targets.forEach( revealSection );
		revealFooter( gsap, footerColumns );
		revealNewsletter( gsap, newsletter );
		return;
	}

	const observer = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( ! entry.isIntersecting ) return;
				observer.unobserve( entry.target );
				if ( entry.target.dataset.scrollRevealType === 'footer-columns' ) {
					revealFooter( gsap, footerColumns );
					return;
				}
				if ( entry.target.dataset.scrollRevealType === 'newsletter' ) {
					revealNewsletter( gsap, newsletter );
					return;
				}
				revealSection( entry.target );
			} );
		},
		{ rootMargin: '0px 0px -12% 0px' }
	);

	targets.forEach( ( target ) => observer.observe( target ) );
	if ( footerColumns.length ) {
		const footerColumnsContainer = footerColumns[ 0 ].closest( '.site-footer__columns' );
		if ( footerColumnsContainer ) {
			footerColumnsContainer.dataset.scrollRevealType = 'footer-columns';
			observer.observe( footerColumnsContainer );
		}
	}
	if ( newsletter ) {
		newsletter.dataset.scrollRevealType = 'newsletter';
		observer.observe( newsletter );
	}
}

function revealFooter( gsap, footerColumns ) {
	if ( ! footerColumns.length || footerColumns[ 0 ].dataset.scrollRevealInit ) return;
	footerColumns.forEach( ( column ) => {
		column.dataset.scrollRevealInit = '1';
	} );
	gsap.fromTo(
		footerColumns,
		{ y: 40, autoAlpha: 0 },
		{ y: 0, autoAlpha: 1, duration: 0.8, ease: 'power2.out', stagger: 0.1, overwrite: 'auto' }
	);
}

function revealNewsletter( gsap, newsletter ) {
	if ( ! newsletter || newsletter.dataset.scrollRevealInit ) return;
	newsletter.dataset.scrollRevealInit = '1';
	gsap.fromTo(
		newsletter,
		{ y: 24, autoAlpha: 0 },
		{ y: 0, autoAlpha: 1, duration: 0.8, ease: 'power2.out', overwrite: 'auto' }
	);
}

function shouldSkipSectionReveal( element ) {
	return (
		element.classList.contains( 'hero-widget' ) ||
		!! element.closest( '.hero-widget, .product-bundle-showcase-widget, .site-header, .site-footer' )
	);
}
